import { useTranslation } from 'react-i18next'
import { Navigation } from 'swiper/modules'
import { Swiper, SwiperSlide } from 'swiper/react'

import { ProductPreviewCard } from '@widgets/product-preview'

import { Product } from '@shared/generated'
import ArrowLink from '@shared/ui/arrow-link'
import CardSkeleton from '@shared/ui/card-skeleton'

import styles from './styles.module.scss'

interface ProductCarouselProps {
  title?: string;
  products: Product[];
  link?: string;
  loading?: boolean;
  swiperClassName?: string;
}

function ProductsLoading () {
  return (
    <div className={styles.skeleton}>
      {Array.from({ length: 8 }).map((_, index) => (
        <CardSkeleton key={index} />
      ))}
    </div>
  )
}

export function ProductCarousel (props: ProductCarouselProps) {
  const { title, products, link, loading, swiperClassName } = props
  const { t: tc } = useTranslation('common')

  if (loading) {
    return <ProductsLoading />
  }

  if (!products?.length) {
    return null
  }

  return (
    <section className={styles.root}>
      {(title || link) && (
        <div className={styles.root__top}>
          {title && <h2 className={styles.root__title}>{title}</h2>}
          {link && <ArrowLink to={link} text={tc('more')} />}
        </div>
      )}

      <Swiper
        spaceBetween={8}
        slidesPerGroup={2}
        slidesPerView="auto"
        modules={[ Navigation ]}
        navigation={true}
        className={swiperClassName}
      >
        {products.map((p) => {
          return (
            <SwiperSlide className={styles.slide} key={p.id}>
              <ProductPreviewCard data={p as Product} />
            </SwiperSlide>
          )
        })}
      </Swiper>
    </section>
  )
}
